import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useParams } from 'react-router-dom';
import { toast } from 'sonner';

const ImageUploader = ({
  profileImageUrl,
  buttonLabel,
  uploadAndSaveHandler,
  bodyLabel,
  name,
}) => {
  const { id: patientId } = useParams();
  const [selectedFile, setSelectedFile] = useState(null);
  const [imageUrl, setImageUrl] = useState(profileImageUrl || null);

  useEffect(() => {
    if (profileImageUrl) {
      setImageUrl(profileImageUrl);
    }
  }, [profileImageUrl]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      const url = URL.createObjectURL(file);
      setImageUrl(url);
      console.log(file);
    }
  };
  if (!patientId) {
    return;
  }

  const uploadImageHandler = async () => {
    if (selectedFile) {
      toast.promise(uploadAndSaveHandler(selectedFile, patientId), {
        loading: 'Uploading File...',
        success: 'File updated successfully',
        error: (error) => {
          return error.message || 'File update failed';
        },
      });
    }
  };

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center "
      style={{ width: 'fit-content' }}
    >
      <label htmlFor={name} style={{ width: '100%', cursor: 'pointer' }}>
        <Box
          sx={{
            border: '2px dashed #ccc',
            borderRadius: '8px',
            padding: '16px',
            textAlign: 'center',
            cursor: 'pointer',
            width: '210px',
            height: '200px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundImage: imageUrl ? `url(${imageUrl})` : 'none',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          {!imageUrl && (
            <>
              <CloudUploadIcon sx={{ fontSize: 48, color: '#ccc' }} />
              <Typography variant="body1" gutterBottom>
                {bodyLabel || 'Upload Image'}
              </Typography>
            </>
          )}
        </Box>
        <input
          id={name}
          type="file"
          hidden
          onChange={handleFileChange}
          accept="image/*"
        />
      </label>

      {/* Upload Button */}
      <Button
        variant="contained"
        color="primary"
        onClick={uploadImageHandler}
        sx={{ marginTop: '10px' }}
        disabled={!selectedFile}
      >
        {buttonLabel || 'Upload Image'}
      </Button>
    </div>
  );
};

export default ImageUploader;
